import jQuery from 'jquery';
let $ = jQuery;
import gap from 'MOBILE/Gap.js';
import 'MOBILE/OldGap.js';

import './EventCoordinator.js';
import './ArticleContent.js';
import './ResponsiveCells.js';
import './Config.js';

import './Arcade/ArcadePopupCoordinator.js';

import './Rewards/Rewards.js';

import './Service.js';
import './Service/AccountService.js';
import './Service/ArcadeService.js';
import './Service/CommerceService.js';
import './Service/FavoriteService.js';
import './Service/PaymentService.js';
import './Service/AddressService.js';
import './Service/ProductTabService.js';
import './Service/ProductService.js';
import './Service/WatchService.js';
import './Service/WidgetService.js';
import './Service/AgentPortal';

import './ArticleModal.js';
import './BaseballCardModal.js';
import './BonusBuyModal.js';
import './BrandsEditModal.js';
import './CouponModal.js';
import './ContentModal.js';
import './CSReportModal.js';
import './EmailCaptureModal.js';
import './PrivateSaleEmailCaptureModal.js';
import './EmailFriendsModal.js';
import './EmailFriendsEnsembleModal.js';
import './EmailSurveyModal.js';
import './FaqEmailFriendModal.js';
import './FitGuideModal.js';
import './GenericConfirmModal.js';
import './HsnCaresDisclaimerModal.js';
import './KashReminderModal.js';
import './MultiItemBagModal.js';
import './OrdersRateReviewModal.js';
import './OrdersReprintLabelModal.js';
import './OrdersReturnLabelModal.js';
import './OrdersTrackOrderModal.js';
import './PageIdModal.js';
import './RatingModal.js';
import './AlcoholModal.js';
import './AsIsModal.js';
import './ReportReviewModal.js';
import './Modals/SigninModal.js';
import './SignupMessageModal.js';
import './VIPFinancingModal.js';
import './WarrantyModal.js';
import './WriteReviewModal.js';
import './YoutubeModal.js';

import './Exchange/ExchangeModal.js';

import './Modals/MyAccount/CancelOrderModal.js';
import './Modals/MyAccount/ProfileImageUploadModal.js';
import './Modals/MyAccount/FlexPayManagerPayNowModal.js';

import './Modals/Checkout/CardVerificationModal.js';
import './Modals/Checkout/CardVerificationRetryModal.js';
import './Modals/Checkout/GiftOptionsModal.js';
import './Modals/Checkout/ShippingPhoneNumberModal.js';
import './Modals/Checkout/SoldOutModal.js';
import './Modals/Checkout/WarrantyUpsellModal.js';

import './OffCanvas/Checkout/EditOptionsOffCanvas.js';
import './OffCanvas/Checkout/AddedToBag.js';

import './Modals/Watch/PastShowModal.js';
import './Modals/Watch/ProgramGuidePrintModal.js';
import './Modals/Watch/ShowDetailsModalv2.js';
import './Modals/MyAccount/ClickToCallModal.js';

import './OffCanvas/Product/ProductPreview.js';

// Used by content
import 'HSNDIR/Metrics.js';
import 'HSNDIR/SmartBanner.js';

/**
* class HSN.Application
*
* Keeps state of the current page loaded into the browser and provides a
* consistent and abstracted API for interacting with that page.
**/
HSN.Application = function (canvas, deviceInfo, flyoutManager, accountNavigation, desktopMobileInjector) {
    /**
* new HSN.Application(canvas, flyoutManager, accountNavigation)
* - canvas: (HtmlElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that is the root canvas of the application.
* - deviceInfo: (HtmlElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that is the JSON string of device information.
* - flyoutManager ([[HSN.FlyoutManager]]): The flyout manager that will coordinate interaction between all registered [[HSN.Flyout]]s.
* - accountNavigation ([[HSN.AccountNavigation]]): The account navigation class that will manage the drawers.
*
* Instantiates and returns a new [[HSN.Application]] that may be passed to
* [[HSN.Instance]] which will provide it as a singleton to anything that
* needs to interact with the page.
**/

    this.Events = new HSN.EventCoordinator();
    this.Canvas = $(canvas);
    this.FlyoutManager = flyoutManager;
    this.AccountNavigation = accountNavigation;
    if (typeof accountNavigation != 'undefined' && accountNavigation !== null) {
        this.AccountNavigation.SetApplicationInstance(this);
    }

    var deviceJson = $(deviceInfo).html();
    this.DeviceInformation = deviceJson ? JSON.parse(deviceJson) : null;
    
    var scope = this;
    $.ajax({
        url: '/api/device-information',
        beforeSend: function (xhr) {
            xhr.setRequestHeader('X-Requested-With', { toString: function () { return ''; } });
        }
    }).done(function (data) {       
        scope.DeviceInformation = data;
    });

    new HSN.ConfigLoader({
        application: this
    });

    this.dependencies = desktopMobileInjector;
};
HSN.Application.prototype =
{
    _uniqueDartFloodlightNumber: null,
    _favoriteService: null,
    _bagService: null,
    _commerceService: null,
    _productTabService: null,
    _productService: null,
    _accountService: null,
    _paymentService: null,
    _addressService: null,
    _bagModal: null,
    _multiItemBagModal: null,
    _flexPayQuantityErrorModal: null,
    _soldoutModal: null,
    _giftModal: null,
    _warrantyModal: null,
    _ratingModal: null,
    _alcoholModal: null,
    _asIsModal: null,
    _videoModal: null,
    _youtubeModal: null,
    _CancelOrderModal: null,
    _ProfileImageUploadModal: null,
    _OrdersReprintLabelModal: null,
    _OrdersTrackOrderModal: null,
    _OrdersRateReviewModal: null,
    _VIPFinancingModal: null,
    _ExchangeModal: null,
    _GenericConfirmModal: null,
    _RewardEntryModal: null,
    _CodeCollectorEntryModal: null,
    _arcadeService: null,
    _emailCaptureModal: null,
    _privateSaleEmailCaptureModal: null,
    _kashReminderModel: null,
    _watchService: null,
    _widgetService: null,
    _showDetailsModalv2: null,
    _programGuidePrintModal: null,
    _pastShowsModal: null,
    _baseballCardModal: null,
    _signupMessageModal: null,
    _emailSurveyModal: null,
    _hsnCaresDisclaimerModal: null,
    _tsSmsAlertModal: null,
    _signInModal: null,
    _forgotPasswordModal: null,
    _multiAccountFoundModal: null,
    _shippingPhoneNumberModal: null,
    ccTokenizerSocket: null,
    _arcadePopupCoordinator: null,
    _arcadePopupCooridinator: null,
    _ordersReturnLabelModal: null,
    _bonusbuyModal: null,
    _bagFlyout: null,
    _flexPayManagerPayNowModal: null,
    _applePaySession: null,
    _accountStatusData: null,
    _accountStatusDetailData: null,
    _warrantyUpsellModal: null,
    _useFullyQualifiedUrls: false,
    _clickToCallModal: null,
    _editOptionsOffCanvas: null,
    _addedToBagOffCanvas: null,
    _productPreviewOffCanvas: null,
    /**
* HSN.Application#Canvas -> jQuery
*
* Provides access to the jQuery-wrapped element that serves as the root canvas for the application.
**/
    Canvas: null,

    /**
* HSN.Application#Events -> HSN.EventCoordinator
*
* Provides access to the [[HSN.EventCoordinator]] instance that the
* application uses to raise it's events.
**/
    Events: null,

    /**
* HSN.Application#FlyoutManager -> HSN.FlyoutManager
*
* Provides access to the [[HSN.FlyoutManager]] instance the application is holding.
**/
    FlyoutManager: null,

    /**
* HSN.Application#AccountNavigation -> HSN.AccountNavigation
*
* Provides access to the [[HSN.AccountNavigation]] instance the application is holding.
**/
    AccountNavigation: null,

    /**
* HSN.Application#DeviceInformation -> HSN.DeviceInformation
*
* Provides access to the [[HSN.DeviceInformation]] instance the application is holding.
**/
    DeviceInformation: null,

    _getFavoriteService: function () {
        if (!this._favoriteService) {
            this._favoriteService = new HSN.Service.FavoriteService();
        }
        return this._favoriteService;
    },

    _getProductTabService: function () {
        if (!this._productTabService) {
            this._productTabService = new HSN.Service.ProductTabService();
        }
        return this._productTabService;
    },

    _getProductService: function () {
        if (!this._productService) {
            this._productService = new HSN.Service.ProductService();
        }
        return this._productService;
    },

    _getAccountService: function () {
        if (!this._accountService) {
            this._accountService = new HSN.Service.AccountService();
        }
        return this._accountService;
    },

    _getPaymentService: function () {
        if (!this._paymentService) {
            this._paymentService = new HSN.Service.PaymentService();
        }
        return this._paymentService;
    },

    _getAddressService: function () {
        if (!this._addressService) {
            this._addressService = new HSN.Service.AddressService();
        }
        return this._addressService;
    },

    _getArcadeService: function () {
        if (!this._arcadeService) {
            this._arcadeService = new HSN.Service.ArcadeService();
        }
        return this._arcadeService;
    },

    _getWatchService: function () {
        if (!this._watchService) {
            this._watchService = new HSN.Service.WatchService();
        }
        return this._watchService;
    },

    _getWidgetService: function () {
        if (!this._widgetService) {
            this._widgetService = new HSN.Service.WidgetService();
        }
        return this._widgetService;
    },

    _getCommerceService: function () {
        if (!this._commerceService) {
            this._commerceService = new HSN.Service.CommerceService();
        }
        return this._commerceService;
    },

    _getAgentPortalService: function () {
        if (!this._agentPortalService) {
            this._agentPortalService = new HSN.Service.AgentPortal();
        }
        return this._agentPortalService;
    },
    /**
* HSN.Application#Favorite(objectType, objectId, config) -> void
* - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being favorited.
* - objectId (String): The identifier of the object to favorite.
* - config (Object): A configuration object for the call
* - webId (String): The variant of the object to favorite if favoriting product.
*   consisting of the following keys:
*   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
*   - scope (Object): The scope to execute the callback function in.
*
* Favorites the given object with the backend Favorite service and then
* executes the callback, if given, with the success or failure status of
* the call.
*
* If successful, raises an [[HSN.Application.EVENT]].`FAVORITE_FAVORITED`
* event passing the type and identifier of the favorited object for
* handling by other components.
**/
    Favorite: function (objectType, objectId, webId, config) {
        config = (config = config || {});
        this._getFavoriteService().Favorite(objectType, objectId, webId, {
            callback: function (success, favorited) {
                if (success && favorited) {
                    if (favorited > 1) { //updated favorite, unfavorite previous
                        this.Events.Trigger(HSN.Application.EVENT.FAVORITE_UNFAVORITED, objectType, objectId, favorited);
                    }
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_FAVORITED, objectType, objectId, webId);
                }
                else if (success) {
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_FAVORITED, objectType, objectId, webId);
                }
                if (config.callback) {
                    config.callback.call((config.scope || config.callback), success, favorited);
                }
            },
            scope: this
        });
    },

    /**
* HSN.Application#Unfavorite(objectType, objectId, config) -> void
* - objectType (HSN.Service.FavoriteService.OBJECT_TYPE): The type of the object being unfavorited.
* - objectId (String): The identifier of the object to unfavorite.
* - webId (String): The variant of the object to favorite if favoriting product.
* - config (Object): A configuration object for the call
*   consisting of the following keys:
*   - callback (Function): The function to call after the service completes its call. It will recieve a single boolean argument representing the success or failure of the call.
*   - scope (Object): The scope to execute the callback function in.
*
* Unfavorites the given object with the backend Favorite service and then
* executes the callback, if given, with the success or failure status of
* the call.
*
* If successful, raises an [[HSN.Application.EVENT]].`FAVORITE_UNFAVORITED`
* event passing the type and identifier of the unfavorited object for
* handling by other components.
**/
    Unfavorite: function (objectType, objectId, webId, config) {
        config = (config = config || {});
        this._getFavoriteService().Unfavorite(objectType, objectId, webId, {
            callback: function (success, favorited) {
                if (success && favorited) {
                    if (favorited > 1) { //updated favorite, unfavorite previous
                        this.Events.Trigger(HSN.Application.EVENT.FAVORITE_UNFAVORITED, objectType, objectId, favorited);
                    }
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_FAVORITED, objectType, objectId, webId);
                }
                else if (success) {
                    this.Events.Trigger(HSN.Application.EVENT.FAVORITE_UNFAVORITED, objectType, objectId, webId);
                }
                if (config.callback) {
                    config.callback.call((config.scope || config.callback), success);
                }
            },
            scope: this
        });
    },

    GetProductReviews: function (encodedProductName, id, page, recordsPerPage, sortTerm, sortSequence, pfid, ratingFilter, percentRecommended, lessman, config) {
        this._getProductTabService().GetProductReviews(
            encodedProductName, id, page, recordsPerPage, sortTerm, sortSequence, pfid, ratingFilter, percentRecommended, $('cmSource').val() || 'ProductPage', lessman,
            {
                callback: function (success, data) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), success, data);
                    }
                },
                scope: this
            }
        );
    },

    GetProductTab: function (id, tab, config) {
        this._getProductTabService().GetProductTab(
            id, tab,
            {
                callback: function (success, data) {
                    if (config.callback) {
                        config.callback.call((config.scope || config.callback), success, data);
                    }
                },
                scope: this
            }
        );
    },

    FormatAsCurrency: function (sSymbol, vValue) {
        aDigits = vValue.toFixed(2).split('.');
        aDigits[0] = aDigits[0].split('').reverse().join('').replace(/(\d{3})(?=\d)/g, '$1,').split('').reverse().join('');

        return sSymbol + aDigits.join('.');
    },

    SingleOrderStatus: function (phoneNumber, orderId, config) {
        config = (config = config || {});
        config.scope = (config.scope = config.scope || this);
        $.ajax
        (
            '/account/order-status/singleitem',
            {
                context: this,
                dataType: 'json',
                type: 'POST',
                data: { 'phoneNumber': phoneNumber, 'orderNumber': orderId, 'isSingleOrder': 'true' },
                success: function (data, status, xhr) {
                    if (data.success) {
                        if (config.success) {
                            config.success.call(config.scope, data);
                        }
                    }
                    else if (config.failure) {
                        config.failure.call(config.scope, data);
                    }
                },
                error: function (xhr, status, error) {
                    if (config.error) {
                        config.error.call(config.error, config.scope, error);
                    }
                }
            }
        );
    },

    GetBagFlyout: function () {
        return this._bagFlyout;
    },
    SetBagFlyout: function (flyout) {
        this._bagFlyout = flyout;
    },
    /**
    * HSN.Application#InitModal -> HSN.Modal
    *
    * @param {function} modalConstructor
    * @param {object} config
    **/
    InitModal: function(modalConstructor, config){
        var instanceName = '__' + modalConstructor.name;
        if(null == this[instanceName]){
            this[instanceName] = new modalConstructor(config);
            this.Canvas.append(this[instanceName].Root);
        }
        return this[instanceName];
    },

    /**
* HSN.Application#GetProductModal -> HSN.ProductModal
*
* Provides access to the lazy-instantiated [[HSN.ProductModal]] that the [[HSN.Application]] is holding.
* This function was left to provide backwards compatibility in case content had calls to the old product modal
**/
    GetProductModal: function () {
        if (null == this._productPreviewOffCanvas) {
            this._productPreviewOffCanvas = new HSN.OffCanvas.ProductPreview();
            this.Canvas.append(this._productPreviewOffCanvas.Root);
        }
        return this._productPreviewOffCanvas;
    },

    /**
    * HSN.Application#GetMobileAddedToBagModal -> HSN.BagModal
    *
    * Provides access to the lazy-instantiated [[HSN.BagModal]] that the [[HSN.Application]] is holding.
    **/
    GetMobileAddedToBagModal: function () {
        if (null == this._bagModal) {
            this._bagModal = new this.dependencies.BagModal();
            this.Canvas.append(this._bagModal.Root);
        }

        return this._bagModal;
    },

    GetMultiItemBagModal: function () {
        if (null == this._multiItemBagModal) {
            this._multiItemBagModal = new HSN.MultiItemBagModal();
            this.Canvas.append(this._multiItemBagModal.Root);
        }

        return this._multiItemBagModal;
    },

    GetSoldOutModal: function () {
        if (null == this._soldoutModal) {
            this._soldoutModal = new HSN.SoldOutModal();
            this.Canvas.append(this._soldoutModal.Root);
        }

        return this._soldoutModal;
    },
    GetExchangeModal: function () {
        if (null == this._ExchangeModal) {
            this._ExchangeModal = new HSN.ExchangeModal();
            this.Canvas.append(this._ExchangeModal.Root);
        }

        return this._ExchangeModal;
    },

    /**
* HSN.Application#GetRatingModal -> HSN.RatingModal
*
* Provides access to the lazy-instantiated [[HSN.RatingModal]] that the [[HSN.Application]] is holding.
**/
    GetRatingModal: function () {
        if (null == this._ratingModal) {
            this._ratingModal = new HSN.RatingModal();
            this.Canvas.append(this._ratingModal.Root);
        }

        return this._ratingModal;
    },

    GetAlcoholModal: function () {
        if (null === this._alcoholModal) {
            this._alcoholModal = new HSN.AlcoholModal();
            this.Canvas.append(this._alcoholModal.Root);
        }

        return this._alcoholModal;
    },

    GetAsIsModal: function () {
        if (null == this._asIsModal) {
            this._asIsModal = new HSN.AsIsModal();
            this.Canvas.append(this._asIsModal.Root);
        }

        return this._asIsModal;
    },

    GetVideoModal: function () {
        if (!this._videoModal) {
            this._videoModal = new this.dependencies.VideoModal();
            this.Canvas.append(this._videoModal.Root);
        }

        return this._videoModal;
    },

    GetYoutubeModal: function () {
        if (!this._youtubeModal) {
            this._youtubeModal = new HSN.YoutubeModal();
            this.Canvas.append(this._youtubeModal.Root);
        }

        return this._youtubeModal;
    },

    //grab specifc param from querystring
    GetQueryStringParam: function (url, param) {
        var queryString = url.substring(url.indexOf('?') + 1);

        var params = queryString.split('&');
        var paramsLength = params.length;
        for (var i = 0; i < paramsLength; i++) {
            var sParameterName = params[i].split('=', 2);
            if (sParameterName[0] == param) {
                return decodeURIComponent(sParameterName[1].replace(/\+/g, ' '));
            }
        }
        return '';
    },

    UpdateQueryStringParameter: function (uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';

        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        }
        else {
            return uri + separator + key + '=' + value;
        }
    },

    //call keyword search logger
    LogKeywordSearch: function (searchTerm, numResults, wasSuggested, wasRedirect) {
        if (!searchTerm) {
            return;
        }

        jQuery.ajax('/search/log', {
            data: {
                'searchTerm': searchTerm,
                'numResults': numResults,
                'wasSuggested': wasSuggested,
                'wasRedirect': wasRedirect
            },
            type: 'GET'
        });
    },

    /**
* HSN.Application#GetBrowser -> HSN.Browser
*
* Returns browser name and version.
**/
    GetBrowser: function () {
        var nav = navigator.appName, ua = navigator.userAgent.toLowerCase(), tem;
        var match = ua.match(/(opera|chrome|safari|firefox|msie|iphone|ipod|ipad|android|blackBerry)/);
        var version = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/);
        if (version && (tem = ua.match(/version\/([\.\d]+)/i)) != null) {
            version[2] = tem[1];
        }
        version = version ? [version[1], version[2]] : [nav, navigator.appVersion, '-?'];
        var browserObj = [match && match[0] ? match[0] : 'unknown', version && version[1] ? version[1] : 'unknown'];
        return browserObj;
    },

    /**
* HSN.Application#GetWriteReviewModal -> HSN.NicknameModal
*
* Provides access to the lazy-instantiated [[HSN.NickanmeModal]] that the [[HSN.Application]] is holding.
**/
    GetNicknameModal: function () {
        if (null == this._nicknameModal) {
            this._nicknameModal = new this.dependencies.NicknameModal();
            this.Canvas.append(this._nicknameModal.Root);
        }

        return this._nicknameModal;
    },
    GetCSReportModal: function () {
        if (null == this._csreportModal) {
            this._csreportModal = new HSN.CSReportModal();
            this.Canvas.append(this._csreportModal.Root);
        }

        return this._csreportModal;
    },
    /**
* HSN.Application#GetWriteReviewModal -> HSN.WriteReviewModal
*
* Provides access to the lazy-instantiated [[HSN.WriteReviewModal]] that the [[HSN.Application]] is holding.
**/
    GetWriteReviewModal: function () {
        if (null == this._writeReviewModal) {
            this._writeReviewModal = new HSN.WriteReviewModal();
            this.Canvas.append(this._writeReviewModal.Root);
        }

        return this._writeReviewModal;
    },

    GetCouponModal: function () {
        if (null == this._couponModal) {
            this._couponModal = new HSN.CouponModal();
            this.Canvas.append(this._couponModal.Root);
        }

        return this._couponModal;
    },

    /**
* HSN.Application#GetArticleModal -> HSN.ArticleModal
*
* Provides access to the lazy-instantiated [[HSN.ArticleModal]] that the [[HSN.Application]] is holding.
**/
    GetArticleModal: function () {
        if (null == this._articleModal) {
            this._articleModal = new HSN.ArticleModal();
            this.Canvas.append(this._articleModal.Root);
        }

        return this._articleModal;
    },

    GetArticleContent: function (config) {
        if (null == this._articleContent) {
            this._articleContent = new HSN.ArticleContent(config);
            this.Canvas.append(this._articleContent.Root);
        }

        return this._articleContent;
    },

    GetContentModal: function () {
        if (null == this._contentModal) {
            this._contentModal = new HSN.ContentModal();
            this.Canvas.append(this._contentModal.Root);
        }

        return this._contentModal;
    },

    GetHsnCaresDisclaimerModal: function () {
        if (null == this._hsnCaresDisclaimerModal) {
            this._hsnCaresDisclaimerModal = new HSN.HsnCaresDisclaimerModal();
            this.Canvas.append(this._hsnCaresDisclaimerModal.Root);
        }

        return this._hsnCaresDisclaimerModal;
    },

    GetReportReviewModal: function () {
        if (null == this._reportReviewModal) {
            this._reportReviewModal = new HSN.ReportReviewModal();
            this.Canvas.append(this._reportReviewModal.Root);
        }

        return this._reportReviewModal;
    },

    GetFitGuideModal: function () {
        if (null == this._fitGuideModal) {
            this._fitGuideModal = new HSN.FitGuideModal();
            this.Canvas.append(this._fitGuideModal.Root);
        }

        return this._fitGuideModal;
    },

    GetEmailFriendsModal: function () {
        if (null == this._emailFriendsModal) {
            this._emailFriendsModal = new HSN.EmailFriendsModal();
            this.Canvas.append(this._emailFriendsModal.Root);
        }

        return this._emailFriendsModal;
    },

    GetEmailFriendsEnsembleModal: function () {
        if (null == this._emailFriendsEnsembleModal) {
            this._emailFriendsEnsembleModal = new HSN.EmailFriendsEnsembleModal();
            this.Canvas.append(this._emailFriendsEnsembleModal.Root);
        }

        return this._emailFriendsEnsembleModal;
    },

    GetBrandsEditModal: function () {
        if (null == this._brandsEditModal) {
            this._brandsEditModal = new HSN.BrandsEditModal();
            this.Canvas.append(this._brandsEditModal.Root);
        }

        return this._brandsEditModal;
    },

    GetSignupMessageModal: function () {
        if (null == this._signupMessageModal) {
            this._signupMessageModal = new HSN.SignupMessageModal();
            this.Canvas.append(this._signupMessageModal.Root);
        }

        return this._signupMessageModal;
    },

    GetEmailSurveyModal: function () {
        if (null == this._emailSurveyModal) {
            this._emailSurveyModal = new HSN.EmailSurveyModal();
            this.Canvas.append(this._emailSurveyModal.Root);
        }

        return this._emailSurveyModal;
    },

    GetPageIdModal: function () {
        if (null == this._pageIdModal) {
            this._pageIdModal = new HSN.PageIdModal();
            this.Canvas.append(this._pageIdModal.Root);
        }

        return this._pageIdModal;
    },

    GetFaqEmailFriendsModal: function () {
        if (null == this._faqEmailFriendsModal) {
            this._faqEmailFriendsModal = new HSN.FaqEmailFriendsModal();
            this.Canvas.append(this._faqEmailFriendsModal.Root);
        }

        return this._faqEmailFriendsModal;
    },
    /**
* HSN.Application#GetGiftOptionsModal -> HSN.GiftModal
*
* Provides access to the lazy-instantiated [[HSN.GiftOptionsModal]] that the [[HSN.Application]] is holding.
**/
    GetGiftOptionsModal: function () {
        if (null == this._giftModal) {
            this._giftModal = new HSN.GiftOptionsModal();
            this.Canvas.append(this._giftModal.Root);
        }

        return this._giftModal;
    },
    /**
* HSN.Application#GetWarrantyDetailsModal -> HSN.WarrantyModal
*
* Provides access to the lazy-instantiated [[HSN.GiftModal]] that the [[HSN.Application]] is holding.
**/
    GetWarrantyDetailsModal: function () {
        if (null == this._warrantyModal) {
            this._warrantyModal = new HSN.WarrantyModal();
            this.Canvas.append(this._warrantyModal.Root);
        }

        return this._warrantyModal;
    },
    /**
* HSN.Application#GetGenericConfirmModal -> HSN.GenericConfirmModal
*
* Provides access to the lazy-instantiated [[HSN.GenericConfirmModal]] that the [[HSN.Application]] is holding.
**/
    GetGenericConfirmModal: function (config) {
        if (null == this._GenericConfirmModal) {
            this._GenericConfirmModal = new HSN.GenericConfirmModal(config);
            this.Canvas.append(this._GenericConfirmModal.Root);
        }

        return this._GenericConfirmModal;
    },
    /**
* HSN.Application#GetFlexPayManagerPayNowModal -> HSN.FlexPayManagerPayNowModal
*
* Provides access to the lazy-instantiated [[HSN.FlexPayManagerPayNowModal]] that the [[HSN.Application]] is holding.
**/
    GetFlexPayManagerPayNowModal: function () {
        if (null == this._flexPayManagerPayNowModal) {
            this._flexPayManagerPayNowModal = new HSN.FlexPayManagerPayNowModal();
            this.Canvas.append(this._flexPayManagerPayNowModal.Root);
        }

        return this._flexPayManagerPayNowModal;
    },
    /**
* HSN.Application#GetCancelOrderModal -> HSN.CancelOrderModal
*
* Provides access to the lazy-instantiated [[HSN.CancelOrderModal]] that the [[HSN.Application]] is holding.
**/
    GetCancelOrderModal: function () {
        if (null == this._CancelOrderModal) {
            this._CancelOrderModal = new HSN.CancelOrderModal();
            this.Canvas.append(this._CancelOrderModal.Root);
        }

        return this._CancelOrderModal;
    },
        /**
* HSN.Application#GetProfileImageUploadModal -> HSN.ProfileImageUploadModal
*
* Provides access to the lazy-instantiated [[HSN.ProfileImageUploadModal]] that the [[HSN.Application]] is holding.
**/
    GetProfileImageUploadModal: function () {
        if (null == this._ProfileImageUploadModal) {
            this._ProfileImageUploadModal = new HSN.ProfileImageUploadModal();
            this.Canvas.append(this._ProfileImageUploadModal.Root);
        }

        return this._ProfileImageUploadModal;
    },
    /**
* HSN.Application#GetOrdersReprintLabelModal -> HSN.OrdersReprintLabelModal
*
* Provides access to the lazy-instantiated [[HSN.OrdersReprintLabelModal]] that the [[HSN.Application]] is holding.
**/
    GetOrdersReprintLabelModal: function () {
        if (null == this._OrdersReprintLabelModal) {
            this._OrdersReprintLabelModal = new HSN.OrdersReprintLabelModal();
            this.Canvas.append(this._OrdersReprintLabelModal.Root);
        }

        return this._OrdersReprintLabelModal;
    },
    /**
* HSN.Application#GetOrdersTrackOrderModal -> HSN.OrdersTrackOrderModal
*
* Provides access to the lazy-instantiated [[HSN.OrdersTrackOrderModal]] that the [[HSN.Application]] is holding.
**/
    GetOrdersTrackOrderModal: function () {
        if (null == this._OrdersTrackOrderModal) {
            this._OrdersTrackOrderModal = new HSN.OrdersTrackOrderModal();
            this.Canvas.append(this._OrdersTrackOrderModal.Root);
        }

        HSN.DataLayer.helpers.virtualPageview(null, 'Modal: Track Order', 'Track Order');

        return this._OrdersTrackOrderModal;
    },
    /**
    * HSN.Application#GetVIPFinancingModal -> HSN.VIPFinancingModal
    *
    * Provides access to the lazy-instantiated [[HSN.VIPFinancingModal]] that the [[HSN.Application]] is holding.
    **/
    GetVIPFinancingModal: function () {
        if (null == this._VIPFinancingModal) {
            this._VIPFinancingModal = new HSN.VIPFinancingModal();
            this.Canvas.append(this._VIPFinancingModal.Root);
        }

        return this._VIPFinancingModal;
    },

    /**
* HSN.Application#RewardEntryModal -> HSN.RewardEntryModal
*
* Provides access to the lazy-instantiated [[HSN.RewardEntryModal]] that the [[HSN.Application]] is holding.
**/
    GetRewardEntryModal: function (config) {
        if (null == this._RewardEntryModal) {
            this._RewardEntryModal = new HSN.RewardEntryModal(config);
            this.Canvas.append(this._RewardEntryModal.Root);
        }

        return this._RewardEntryModal;
    },
    /**
* HSN.Application#CodeCollectorEntryModal -> HSN.CodeCollectorEntryModal
*
* Provides access to the lazy-instantiated [[HSN.CodeCollectorEntryModal]] that the [[HSN.Application]] is holding.
**/
    GetCodeCollectorEntryModal: function (config) {
        if (null == this._CodeCollectorEntryModal) {
            this._CodeCollectorEntryModal = new HSN.CodeCollectorModal(config);
            this.Canvas.append(this._CodeCollectorEntryModal.Root);
        }

        return this._CodeCollectorEntryModal;
    },
    /**
    * HSN.Application#GetBaseballCardModal -> HSN.BaseballCardModal
    *
    * Provides access to the lazy-instantiated [[HSN.BaseballCardModal]] that the [[HSN.Application]] is holding.
    **/
    GetBaseballCardModal: function (config) {
        if (null == this._baseballCardModal) {
            this._baseballCardModal = new HSN.BaseballCardModal(config);
            this.Canvas.append(this._baseballCardModal.Root);
        }

        return this._baseballCardModal;
    },
    /**
* HSN.Application#GetEmailCaptureModal -> HSN.EmailCaptureModal
*
* Provides access to the lazy-instantiated [[HSN.EmailCaptureModal]] that the [[HSN.Application]] is holding.
**/
    GetEmailCaptureModal: function (config) {
        if (null == this._emailCaptureModal) {
            this._emailCaptureModal = new HSN.EmailCaptureModal(config);
            this.Canvas.append(this._emailCaptureModal.Root);
        }

        return this._emailCaptureModal;
    },
/**
* HSN.Application#GetPrivateSaleEmailCaptureModal -> HSN.PrivateSaleEmailCaptureModal
*
* Provides access to the lazy-instantiated [[HSN.PrivateSaleEmailCaptureModal]] that the [[HSN.Application]] is holding.
**/
    GetPrivateSaleEmailCaptureModal: function (config) {
        if (null == this._privateSaleEmailCaptureModal) {
            this._privateSaleEmailCaptureModal = new HSN.PrivateSaleEmailCaptureModal(config);
            this.Canvas.append(this._privateSaleEmailCaptureModal.Root);
        }

        return this._privateSaleEmailCaptureModal;
    },
    /**
* HSN.Application#GetKashReminderModal -> HSN.KashReminderModal
*
* Provides access to the lazy-instantiated [[HSN.KashReminderModal]] that the [[HSN.Application]] is holding.
**/
    GetKashReminderModal: function (config) {
        if (null == this._kashReminderModal) {
            this._kashReminderModal = new HSN.KashReminderModal(config);
            this.Canvas.append(this._kashReminderModal.Root);
        }

        return this._kashReminderModal;
    },
    /**
* HSN.Application#GetShowDetailsModal -> HSN.ShowDetailsModal
*
* Provides access to the lazy-instantiated [[HSN.ShowDetailsModal]] that the [[HSN.Application]] is holding.
**/
    GetShowDetailsModalv2: function (config) {
        if (null == this._showDetailsModalv2) {
            this._showDetailsModalv2 = new HSN.ShowDetailsModalv2(config);
            this.Canvas.append(this._showDetailsModalv2.Root);
        }

        return this._showDetailsModalv2;
    },
    GetProgramGuidePrintModal: function(config) {
        if(null == this._programGuidePrintModal) {
            this._programGuidePrintModal = new HSN.ProgramGuidePrintModal(config);
            this.Canvas.append(this._programGuidePrintModal.Root);
        }

        return this._programGuidePrintModal;
    },
    GetPastShowsModal: function(config) {
        if (null == this._pastShowsModal) {
            this._pastShowsModal = new HSN.PastShowModal(config);
            this.Canvas.append(this._pastShowsModal.Root);
        }

        return this._pastShowsModal;
    },
    GetSignInModal: function (config) {
        if (null == this._signInModal) {
            this._signInModal = new HSN.SignInModal(config);
            this.Canvas.append(this._signInModal.Root);
        }

        return this._signInModal;
    },
    GetForgotPasswordModal: function (config) {
        if (null == this._forgotPasswordModal) {
            this._forgotPasswordModal = new HSN.ForgotPasswordModal(config);
            this.Canvas.append(this._forgotPasswordModal.Root);
        }

        return this._forgotPasswordModal;
    },
    GetMultiAccountFoundModal: function (config) {
        if (null == this._multiAccountFoundModal) {
            this._multiAccountFoundModal = new HSN.MultiAccountFoundModal(config);
            this.Canvas.append(this._multiAccountFoundModal.Root);
        }

        return this._multiAccountFoundModal;
    },
    GetShippingPhoneNumberModal: function () {
        if (null == this._shippingPhoneNumberModal) {
            this._shippingPhoneNumberModal = new HSN.ShippingPhoneNumberModal();
            this.Canvas.append(this._shippingPhoneNumberModal.Root);
        }
        return this._shippingPhoneNumberModal;
    },
    GetOrdersReturnLabelModal: function () {
        if (null == this._ordersReturnLabelModal) {
            this._ordersReturnLabelModal = new HSN.OrdersReturnLabelModal();
            this.Canvas.append(this._ordersReturnLabelModal.Root);
        }
        return this._ordersReturnLabelModal;
    },
    GetBonusBuyModal: function () {
        if (null == this._bonusbuyModal) {
            this._bonusbuyModal = new HSN.BonusBuyModal();
            this.Canvas.append(this._bonusbuyModal.Root);
        }
        return this._bonusbuyModal;
    },
    GetCardVerificationModal: function (config) {
        if (null == this._cardVerificationModal) {
            this._cardVerificationModal = new HSN.CardVerificationModal(config);
            this.Canvas.append(this._cardVerificationModal.Root);
        }
        return this._cardVerificationModal;
    },
    GetCardVerificationRetryModal: function (config) {
        if (null == this._cardVerificationRetryModal) {
            this._cardVerificationRetryModal = new HSN.CardVerificationRetryModal(config);
            this.Canvas.append(this._cardVerificationRetryModal.Root);
        }
        return this._cardVerificationRetryModal;
    },
    GetWarrantyUpsellModal: function(config) {
        if(null == this._warrantyUpsellModal) {
            this._warrantyUpsellModal = new HSN.WarrantyUpsellModal(config);
            this.Canvas.append(this._warrantyUpsellModal.Root);
        }
        return this._warrantyUpsellModal;
    },

    GetClickToCallModal: function (config) {
        if (null == this._clickToCallModal) {
            this._clickToCallModal = new HSN.ClickToCallModal(config);
            this.Canvas.append(this._clickToCallModal.Root);
        }
        return this._clickToCallModal;
    },
    /*
    ====================================================================================================================
    BEGIN OFF CANVAS WIDGETS
    ====================================================================================================================
    */
    GetEditOptionsOffCanvas: function () {
        if (null == this._editOptionsOffCanvas) {
            this._editOptionsOffCanvas = new HSN.EditOptionsOffCanvas();
            this.Canvas.append(this._editOptionsOffCanvas.Root);
        }
        return this._editOptionsOffCanvas;
    },
    GetAddedToBagOffCanvas: function () {
        if (null == this._addedToBagOffCanvas) {
            this._addedToBagOffCanvas = new HSN.AddedToBagOffCanvas();
            this.Canvas.append(this._addedToBagOffCanvas.Root);
        }
        return this._addedToBagOffCanvas;
    },
    GetProductPreviewOffCanvas: function () {
        if (null == this._productPreviewOffCanvas) {
            this._productPreviewOffCanvas = new HSN.OffCanvas.ProductPreview();
            this.Canvas.append(this._productPreviewOffCanvas.Root);
        }
        return this._productPreviewOffCanvas;
    },

    /*
    ====================================================================================================================
    END OFF CANVAS WIDGETS
    ====================================================================================================================
    */
    HandleEmailSignup: function (emailAddress, source, config) {
        config = (config = config || {});
        $.ajax('/account/emailcapture/signup', {
            context: this,
            dataType: 'json',
            type: 'POST',
            data: { 'emailAddress': emailAddress, 'sourceId': source },
            success: function (data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                }
                else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function (xhr, status, error) {
                if (config.error) {
                    config.error.call(config.error, config.scope, error);
                }
            }
        });

    },
    FlexPaymentMethod: function (action, orderNumber, flexNumber, identity, defaultFlag, month, year, name, type, debitFlag, saveFlag, ccnumber, cctoken, bankName, config) {
        config = (config = config || {});
        config.scope = (config.scope = config.scope || this);
        //alert(identity + ',' + password);

        $.ajax('/myaccount/flexpay/changecard', {
            context: this,
            dataType: 'json',
            type: 'POST',
            // TODO: These parameter names must be updated to match the service endpoint expectation.
            data: { 'Action': action, 'OrderNumber': orderNumber, 'FlexNumber': flexNumber, 'Identity': identity, 'DefaultFlag': defaultFlag, 'Month': month, 'Year': year, 'Name': name, 'Type': type, 'DebitFlag': debitFlag, 'SaveFlag': saveFlag, 'Number': ccnumber, 'PaymentMethodToken': cctoken, 'BankName': bankName },
            success: function (data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                }
                else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function (xhr, status, error) {
                if (config.error) {
                    config.error.call(config.error, config.scope, error);
                }
            }
        });
    },
    AutoshipPaymentMethod: function (action, orderNumber, identity, defaultFlag, month, year, name, type, debitFlag, saveFlag, ccnumber, cctoken, bankName, config) {
        config = (config = config || {});
        config.scope = (config.scope = config.scope || this);
        //alert(identity + ',' + password);

        $.ajax('/myaccount/autoship/changecard', {
            context: this,
            dataType: 'json',
            type: 'POST',
            // TODO: These parameter names must be updated to match the service endpoint expectation.
            data: { 'Action': action, 'OrderNumber': orderNumber, 'Identity': identity, 'DefaultFlag': defaultFlag, 'Month': month, 'Year': year, 'Name': name, 'Type': type, 'DebitFlag': debitFlag, 'SaveFlag': saveFlag, 'Number': ccnumber, 'PaymentMethodToken': cctoken, 'BankName': bankName },
            success: function (data, status, xhr) {
                if (data.success) {
                    if (config.success) {
                        config.success.call(config.scope, data);
                    }
                }
                else if (config.failure) {
                    config.failure.call(config.scope, data);
                }
            },
            error: function (xhr, status, error) {
                if (config.error) {
                    config.error.call(config.error, config.scope, error);
                }
            }
        });
    },
    IsAutoshipFrequencyValid: function(data) {
        var frequency = data.frequency || 0;

        return frequency >= 7 && frequency <= 365;
    },
    SetGuest: function (config) {
        config = (config = config || {});
        config.scope = (config.scope = config.scope || this);
        $.ajax
        (
            '/account/guest',
            {
                context: this,
                dataType: 'json',
                type: 'POST',
                // TODO: These parameter names must be updated to match the service endpoint expectation.
                data: null,
                success: function (data, status, xhr) {
                    if (data.success) {
                        if (config.success) {
                            config.success.call(config.scope, data);
                        }
                    }
                    else if (config.failure) {
                        config.failure.call(config.scope, data);
                    }
                },
                error: function (xhr, status, error) {
                    if (config.error) {
                        config.error.call(config.error, config.scope, error);
                    }
                }
            }
        );
    },
    ReportIssue: function (name, email, contactMe, description, url, config) {
        config = (config = config || {});
        config.scope = (config.scope = config.scope || this);
        var randomnumber = (Math.floor(Math.random() * 10)) + 100;
        $.ajax
        (
            '/customer-service/report' + '?rnd=' + randomnumber,
            {
                context: this,
                dataType: 'json',
                type: 'POST',
                data: { 'Name': name, 'EmailAddress': email, 'ContactMe': contactMe, 'Description': description, 'URL': url },
                success: function (data, status, xhr) {
                    if (data.success) {
                        if (config.success) {
                            config.success.call(config.scope, data);
                        }
                    }
                    else if (config.failure) {
                        config.failure.call(config.scope, data);
                    }
                },
                error: function (xhr, status, error) {
                    if (config.error) {
                        config.error.call(config.error, config.scope, error);
                    }
                }
            }
        );
    },

    GetMenuData: function (query, lessman) {
        var url = '';
        var params = '?UseBullets=true';

        if (lessman) {
            url = '/lessman-menu/';
        }
        else {
            url = (query) ? '/offcanvas/' + query + params : '/offcanvas/';
            if (query === 'hf0035') {
                url = '/lessman-menu/';
            }
        }

        $.ajax
        (
            url,
            {
                context: this,
                dataType: 'html',

                success: function (data, status, xhr) {
                    this.Events.Trigger(HSN.Application.EVENT.ON_NAVIGATION_LOADED, data);
                }
            }
        );
    },
    /**
* HSN.Application#GetOrdersRateReviewModal -> HSN.OrdersRateReviewModal
*
* Provides access to the lazy-instantiated [[HSN.OrdersRateReviewModal]] that the [[HSN.Application]] is holding.
**/
    GetOrdersRateReviewModal: function () {
        if (null == this._OrdersRateReviewModal) {
            this._OrdersRateReviewModal = new HSN.OrdersRateReviewModal();
            this.Canvas.append(this._OrdersRateReviewModal.Root);
        }

        return this._OrdersRateReviewModal;
    },

    GetUniqueDartFloodlightNumber: function () {
        return this._uniqueDartFloodlightNumber = Number(this._uniqueDartFloodlightNumber) || Math.floor(Math.random() * 10e12);
    },

    DisplayCustomerOffers: function (offers) {
        $.each(offers, function () {
            var offerContainer = $("[offer-location='" + this.Location + "']");
            var $offerHtml = $(this.Html);
            var cmTagValue = this.Location + '-_-' + (this.InControlGroup ? 'Control' : 'Target') + '-_-' + this.TreatmentCode;
            var event = JSON.stringify({
                'event_type': 'metric',
                'metrics_event_category': 'offer',
                'metrics_event_action': 'Accepted',
                "unica_treatment_code": this.TreatmentCode,
                "unica_session_id": this.SessionId,
                "unica_source": 'Web'
            });

            if ((!this.Html && !this.InControlGroup) || offerContainer.length === 0) {//not personalized offer or in control group
                return;
            }

            if (this.InControlGroup && !this.Html) {
                offerContainer.find('a')
                    .add(offerContainer.filter('a'))
                    .attr('manual_cm_re', cmTagValue)
                    .attr('manual_cm_sp', cmTagValue)
                    .attr('data-datalayer-udo', event);
            }
            else {
                $offerHtml.filter('a')
                    .add($offerHtml.find('a'))
                    .attr('data-datalayer-udo', event);

                offerContainer.html($offerHtml);

                // If this cell is the LeftNavGrid cell, activate the separator/spacer + readjust the breadbox and product grid cells
                if(offerContainer.is('#IP_xx_LeftNavGrid')) {
                    $('#IP_xx_LeftNavGrid_Separator').addClass('active');

                    if (typeof window.productGrid === 'object' && productGrid.adjustProductGrid) {
                        productGrid.adjustProductGrid();
                    }
                }
            }
        });
        HSN.ResponsiveCells.prototype.TextResize('.TextContainer', '.rText');
        HSN.ResponsiveCells.prototype.ButtonResize('.rButton', '.rText');
        HSN.ResponsiveCells.prototype.HandleWindowResize();
        $('[offer-location]').removeClass('invisible');
    },

    GetArcadePopupCoordinator: function () {
        if (!this._arcadePopupCoordinator) {
            this._arcadePopupCoordinator = new HSN.ArcadePopupCoordinator();
            this._arcadePopupCoordinator.init({
                application: HSN.Instance()
            });
        }
        return this._arcadePopupCoordinator;
    },

    //checks if Android or IOS features are enabled based on feature name and version number
    GetAppFeatures: function(feature, version) {
        var appFeature = null;
        var appFeatureAndroid = (window.appFeaturesAndroid && window.appFeaturesAndroid !== 'undefined') ? JSON.parse(window.appFeaturesAndroid.toString()) : null;
        var appFeatureIOS = (window.appFeaturesIOS && window.appFeaturesIOS !== 'undefined') ? JSON.parse(window.appFeaturesIOS) : null;

        if (appFeatureAndroid !== null) {
            appFeature = appFeatureAndroid;
        }
        else if (appFeatureIOS !== null) {
            appFeature = appFeatureIOS;
        }

        if (appFeature !== null) {
            if (feature === 'localtyics') {
                if (appFeature.featurelist.localytics === version) {
                    return true;
                }
            }
            if (feature === 'social') {
                if (appFeature.featurelist.social === version) {
                    return true;
                }
            }
            if (feature === 'branch') {
                if (appFeature.featurelist.branch === version) {
                    return true;
                }
            }
            if (feature === 'gapevents') {
                if (appFeature.featurelist.gapevents === version) {
                    return true;
                }
            }
            if (feature === 'writereview') {
                if (appFeature.featurelist.writereview === version) {
                    return true;
                }
            }
        }

        return false;
    },

    ConvertLinks: function () {
        jQuery('a:not(.native-link):not(.not-native-link)').each(function () {
            //Convert all links back to mobile domain
            if ($(this).attr('href')) {
                if ($(this).attr('href').lastIndexOf('http', 0) === -1 && $(this).attr('href').lastIndexOf('#', 0) === -1 && $(this).attr('href').lastIndexOf('//', 0) === -1 && $(this).attr('href').lastIndexOf('tel:', 0) === -1 && $(this).attr('href').lastIndexOf('javascript:', 0) === -1) {
                    $(this).attr('href', gap.ConvertLink($(this).attr('href')));
                }

                if (window.isNativeApp && $(this).attr('href').lastIndexOf('javascript:', 0) === -1) {
                    $(this).addClass('native-link');
                }
            }
        });
    },

    SetApplePaySession: function(session) {
        this._applePaySession = session;
    },

    GetApplePaySession: function () {
        return this._applePaySession;
    },

    SetAccountStatusData: function(data) {
        this._accountStatusData = data;
    },

    GetAccountStatusData: function() {
        return this._accountStatusData;
    },

    SetAccountStatusDetailData: function(data) {
        this._accountStatusDetailData = data;
    },

    GetAccountStatusDetailData: function() {
        return this._accountStatusDetailData;
    },

    SetUseFullyQualifiedUrls: function(data) {
        this._useFullyQualifiedUrls = data;
    },
        
    UseFullyQualifiedUrls: function() {
        return this._useFullyQualifiedUrls;
    }
};

    /**
    * HSN.Application.EVENT = Object
    *
    * An enumeration of events an [[HSN.Application]] can raise:
    * - FAVORITE_FAVORITED: When an item is successfully favorited.
    * - FAVORITE_UNFAVORITED: When an item is successfully unfavorited.
    * - FAVORITE_INITIALIZED: When an item is first displayed as favorited or not.
    * - VISITOR_AUTHENTICATED: When a visitor is authenticated.
    * - BAGITEM_REMOVED: When item is removed from the shopping bag.
    * - BAGITEM_SAVEDFORLATER: When item is saved for later.
    **/
HSN.Application.EVENT =
{
    FAVORITE_FAVORITED: 'favorite:favorited',
    FAVORITE_UNFAVORITED: 'favorite:unfavorited',
    FAVORITE_INITIALIZED: 'favorite:initialized',
    VISITOR_AUTHENTICATED: 'visitor:authenticated',
    BAGITEM_ADDED: 'bagitem:added',
    BAGITEM_REMOVED: 'bagitem:removed',
    BAGITEM_SAVEDFORLATER: 'bagitem:savedforlater',
    BAGITEM_MOVEDTOBAG: 'bagitem:movedtobag',
    BAGITEM_DELETEWARRANTY: 'bagitem:deletewarranty',
    BAGITEM_KEEPSHOPPING: 'bagitem:keepshopping',
    NICKNAME_ADDED: 'nickname:added',
    VIDEO_COMPLETE: 'video:complete',
    CM_LOADED: 'cm:loaded',
    DATALAYER_LOADED: 'datalayer:loaded',
    TEALIUM_LOADED: 'tealium:loaded',
    GTM_LOADED: 'gtm:loaded',
    GOOGANALYTICS_LOADED: 'googanalytics:loaded',
    ARCADE_TICKETBALANCECHANGE: 'arcade:ticketbalancechange',
    ARCADE_HEADER_MOUSELEAVE: 'arcade:headermouseleave',
    GAP_EXECUTECOMMAND: 'gap:executecommand',
    NAVIGATION_LOADED: 'navigation:loaded',
    ON_NAVIGATION_MENU_OPENED: 'navigation:menu_opened',
    ON_NAVIGATION_LOADED: 'navigation:loaded',
    ON_GOOGLE_API_JS_CLIENT_LOADED: 'googlejsclientapi:loaded',
    VIRTUAL_PAGE_VIEW: 'virtualpageview'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Application.js